import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard  {
    private router = inject(Router);


    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem("currentUser")) {
            return true;
        }
        localStorage.removeItem("currentUser");
        // not logged in so redirect to login page with the return url
        this.router.navigate([ '/login' ], { queryParams: { returnUrl: state.url }});
        return false;
    }
}
